import { Breadcrumbs, Button, ButtonGroup, LinearProgress, Menu, MenuItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useEffect, useState } from "react";
import { DataGridPremium, GridActionsCellItem, GridToolbarContainer, GridToolbarQuickFilter, useGridApiRef } from "@mui/x-data-grid-premium";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { format } from 'date-fns';
import AddPoliciesDialog from "./Components/AddPoliciesDialog";
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ConfirmDialog from "../../components/ConfirmDialog";



function DeployWorkspace() {
    const [aaConfig, setAAConfig] = useState(null);
    const [policies, setPolicies] = useState([]);
    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(false);
    const [undeployProcessing, setUndeployProcessing] = useState(false);
    const [deleteProcessing, setDeleteProcessing] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const [policySelectionIndex, setPolicySelectionIndex] = useState({
        type: 'include',
        ids: new Set(),
    });
    const [policiesSelected, setPoliciesSelected] = useState([]);

    const iaam = window.iaam;
    const [openAddPolicies, setOpenAddPolicies] = useState(false);
    const [openConfiemUndeploy, setOpenConfiemUndeploy] = useState(false);


    const columns = [
        {
            field: 'project_name',
            headerName: 'Project Name',
            minWidth: 200,

        },
        {
            field: 'policy_diagram_name',
            headerName: 'Policy Name',
            width: 300,
            flex: 1,
            renderCell: (params) => {
                const onClick = () => {
                    // handleProjectSelected(params.row)
                };
                return <a href="#" className="text-blue-900 font-primary" onClick={onClick}>{params.row.policy_diagram_name}</a>;
            }
        },
        {
            field: 'deployed_by',
            headerName: 'Deployed by',
            width: 220
        },
        {
            field: 'deployed_at',
            headerName: 'Deployed date',
            width: 200
        }
    ];

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOnRowSelectionModel = (newRowSelectionModel) => {

        setPolicySelectionIndex(newRowSelectionModel);
        const listPolicy = policies.filter((value, idx) => newRowSelectionModel.ids.has(idx))
        setPoliciesSelected(listPolicy)

    }

    useEffect(() => {
        const aa_selected = JSON.parse(localStorage.getItem('aa-selected'));
        const initAAConfiguration = async (aa_host) => {
            try {
                setUser(await iaam.getProfile());
                const resp = await fetch(`${aa_host}${process.env.REACT_APP_AA_CONFIGURATION_PATH}`)
                if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
                const aa_conf = await resp.json();
                setAAConfig(aa_conf)
            } catch (error) {
                console.log("set AA Configuration:", error)
                setLoading(false)
                setAAConfig(null)
            }
        }

        if (aa_selected) {
            if (aa_selected?.status === "online")
                initAAConfiguration(aa_selected.aa_url)
        }
    }, []);

    const getPolicies = async () => {
        try {

            const accessToken = await iaam.getAccessToken();
            let option = {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${accessToken}`
                }
            }
            const resp = await fetch(`${aaConfig?.get_policies}`, option)
            if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
            const result = await resp.json();

            if (result?.error) throw result.error
            const list_policy = result.map((item, index) => ({
                ...item,
                id: index,
                created_at: format(new Date(item.created_at), "yyyy-MM-dd HH:mm:ss"),
                last_updated: format(new Date(item.last_updated), "yyyy-MM-dd HH:mm:ss"),
                deployed_at: format(new Date(item.deployed_at), "yyyy-MM-dd HH:mm:ss"),
            }));

            setPolicies(list_policy)
            setLoading(false)
        } catch (error) {
            console.log("can't get policies:", error)
            setLoading(false)
            setPolicies([])
        }
    }

    useEffect(() => {
        if (aaConfig) {
            setLoading(true)
            getPolicies()
        }

    }, [aaConfig])

    const handleOnCloseAddPiliciesDialog = (isUpdatePolicies) => {
        if (isUpdatePolicies) getPolicies();

        setOpenAddPolicies(!openAddPolicies)
    }

    const confirmUndeployPolicies = async () => {
        try {
            setUndeployProcessing(true)
            const accessToken = await iaam.getAccessToken();
            let option = {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${accessToken}`
                },
                body: JSON.stringify({ user: user, policies: policiesSelected })
            };
            const resp = await fetch(`${aaConfig?.undeploy_policy}`, option);
            if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
            const result = await resp.json();
            // console.log(result);
            setUndeployProcessing(false);
            getPolicies();
        } catch (error) {
            console.log("undeploy Policies:", error);
            setUndeployProcessing(false);
            setPolicySelectionIndex({
                type: 'include',
                ids: new Set(),
            });
            setPoliciesSelected([]);
            getPolicies();
        }
    }

    function CustomToolbar(props) {

        return (
            <GridToolbarContainer {...props} className="flex justify-between mt-2 ml-2 mr-3">
                <GridToolbarQuickFilter variant="outlined" size="small" />
                {policySelectionIndex && policySelectionIndex.ids.size > 0 && (
                    <Button variant="outlined" color="error" loading={undeployProcessing} loadingPosition="start" startIcon={<DeleteIcon />} onClick={() => setOpenConfiemUndeploy(true)}>
                        Undeploy
                    </Button>
                )}
            </GridToolbarContainer>
        );
    }

    return (
        <section className="overflow-auto w-full bg-gradient-to-r from-green-50 via-blue-50 to-blue-100">
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 overflow-hidden w-full'>
                <div className='pt-10'>
                    <div role='presentation'>
                        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
                            <Link underline="hover" key="1" color="inherit" component={Link} to="/deployer">
                                <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6'>
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Policy Deployer
                                </Typography>
                            </Link>
                            <Typography color="primary" sx={{ display: 'flex', alignItems: 'center' }} variant='h6'>
                                {aaConfig?.name}
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className='animate-fade-left'>
                    <div className='flex flex-col gap-1 mt-8'>
                        <div className='flex justify-between bg-white rounded-t-md h-24 p-4 border border-gray-200'>
                            <div className='h-full content-evenly'>
                                <Typography variant='h6'>Deploy & Undeploy Policies</Typography>
                                <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}>List of deployed policies with the option to undeploy as needed.</Typography>
                            </div>
                            <div className='h-full content-evenly'>
                                <Button color="success" style={{ textTransform: 'none' }} variant="contained" onClick={() => setOpenAddPolicies(!openAddPolicies)}>
                                    Add Policies
                                </Button>
                            </div>
                        </div>
                        <div className='bg-white rounded-b-md h-[calc(100vh-270px)] max-h-[calc(100vh-178px)] mb-3 border border-gray-200'>
                            <DataGridPremium
                                // apiRef={apiRef}
                                loading={loading}
                                rows={policies}
                                columns={columns}
                                checkboxSelection={!undeployProcessing}
                                disableRowSelectionOnClick
                                showToolbar
                                slots={{ loadingOverlay: LinearProgress, toolbar: CustomToolbar }}
                                sx={{
                                    border: 0
                                }}
                                onRowSelectionModelChange={handleOnRowSelectionModel}
                                rowSelectionModel={policySelectionIndex}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <AddPoliciesDialog aaConfig={aaConfig} user={user} open={openAddPolicies} onClose={handleOnCloseAddPiliciesDialog} />
            <ConfirmDialog
                open={openConfiemUndeploy}
                setOpen={() => setOpenConfiemUndeploy(!openConfiemUndeploy)}
                title="Undeploy Policies"
                description="Are you sure you want to undeploy the selected policies? This action will remove the selected policies from the system."
                confirmLabel="Undeploy"
                confirmColor="error"
                onConfirm={confirmUndeployPolicies} />
        </section>
    )
}

export default DeployWorkspace;